export default __webpack_public_path__ + "static/media/shoe03.98c9aaf1.jpg";